import { SubscriptionStatus } from '../enums/subscription-status.enum';
import { UserProvider } from '../enums/user-provider.enum';
import { UserRole } from '../enums/user-role.enum';
import {
  IReferrerData,
  IUserData,
} from '../services/user/user-data.interface';

export const MOCK_AUTH_TOKEN = 'dev-skip-auth';
export const MOCK_REFERRER_CHANNEL_ID = 'dev-referrer-channel';

const MOCK_USER_ID = 'dev-mock-member-001';
const MOCK_REFERRER_ID = 'dev-mock-referrer-001';

/** Preview-only channel ids — never look these up on the live user API. */
export function isMockReferrerChannelId(
  channelId?: string | null,
): boolean {
  if (!channelId) return false;
  return (
    channelId === MOCK_REFERRER_CHANNEL_ID ||
    channelId === 'guest-channel' ||
    channelId === 'preview-channel' ||
    channelId.startsWith('dev-')
  );
}

/** First real referring channel — skips leftover preview/mock ids. */
export function resolveLiveReferringChannel(
  ...candidates: Array<string | null | undefined>
): string {
  const match = candidates.find((candidate) => {
    const trimmed = candidate?.trim();
    return Boolean(trimmed && !isMockReferrerChannelId(trimmed));
  });

  return match?.trim() ?? '';
}

function createMockReferrer(): IReferrerData {
  return {
    referredBy: null,
    channelId: MOCK_REFERRER_CHANNEL_ID,
    referrerId: MOCK_REFERRER_ID,
    publicDisplayName: 'Dev Referrer',
    channelName: 'dev-referrer',
    channelDisplayName: 'Dev Referrer',
    connections: [],
    created: new Date().toISOString(),
    displayName: 'Dev Referrer',
    isDoNotShowMsg: false,
    isShowFlags: false,
    profileImageURL: '',
    profilePicture: '',
    profileThumbnail: '',
    referralCode: 'DEVREF',
    socialPlatforms: [],
    userStateFlags: [],
    username: 'devreferrer',
    firstName: 'Dev',
    lastName: 'Referrer',
    _id: MOCK_REFERRER_ID,
    isFollowing: false,
    badges: [],
    isFavourite: false,
    serviceAvailabilityStatus: '',
    statusCode: 200,
    data: '',
  };
}

/** Minimal completed member for local dashboard preview. */
export function createMockMemberUser(): IUserData {
  return {
    id: MOCK_USER_ID,
    _id: MOCK_USER_ID,
    username: 'devmember',
    displayName: 'Dev Member',
    channelId: 'dev-member-channel',
    channelName: 'devmember',
    channelDisplayName: 'Dev Member',
    created: new Date().toISOString(),
    email: 'dev.member@localhost',
    isDoNotShowMsg: true,
    isAllowAffiliate: true,
    isTempSubscription: false,
    referVisitors: 0,
    keycloakUserId: 'dev-keycloak-user',
    freeTrialExpiry: '',
    subscriptionStatus: SubscriptionStatus.BASIC,
    viralcamReferralLink: 'http://localhost:4000/?ref=DEVMEMBER',
    referralCode: 'DEVMEMBER',
    socialPlatforms: [],
    advanceGameMode: false,
    premiumUser: false,
    macExperienceLevel: [],
    windowExperienceLevel: [],
    linuxExperienceLevel: [],
    androidExperienceLevel: [],
    iosExperienceLevel: [],
    isOnline: true,
    referPoints: 0,
    isFirstLogin: false,
    isVerified: true,
    roles: [UserRole.USER],
    profileType: 0,
    provider: UserProvider.EMAIL,
    deviceToken: [],
    isDefault: false,
    isBusiness: true,
    hashTags: [],
    answers: [],
    tweetText: '',
    categories: [],
    preRegistered: false,
    isWaiting: false,
    isQuickStarter: false,
    referrerChannel: MOCK_REFERRER_CHANNEL_ID,
    shortUrl: 'http://localhost:4000/r/DEVMEMBER',
    age: '',
    linkedinProfileLink: '',
    instagramProfileLink: '',
    facebookProfileLink: '',
    googleProfileLink: '',
    twitterProfileLink: '',
    about: 'Local mock member for dashboard preview',
    bannerImageURL: '',
    profileThumbnail: '',
    profileImageURL: '',
    refferingChannel: null,
    emailVerification: true,
    lastName: 'Member',
    OauthId: '',
    firstName: 'Dev',
    userStateFlags: [],
    isShowFlags: false,
    refferedBy: createMockReferrer(),
    publicDisplayName: 'Dev Member',
    privateDisplayName: 'Dev Member',
    emailToBeUpdated: null,
    badges: [],
    referralPage: '',
    isOnboardingCompleted: true,
    giftcardId: '',
    giftcardIds: [],
    giftcardCount: 0,
    maxGiftCardsPerUser: '0',
    giftcardFrom: '',
    maxGiftCards: '0',
    hasLoggedInOnAndroid: true,
    hasLoggedInOnIos: true,
    specialSourceOnboarded: true,
    vipTier: '',
  };
}
